//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BCard, BCardBody, BFormCheckboxGroup, BFormCheckbox, BSkeleton, BSkeletonWrapper } from 'bootstrap-vue';
import { Icon } from '@iconify/vue2';

var formatter = new Intl.NumberFormat({
  style: 'currency',
  currency: 'UYU',
  currencyDisplay: "code",
  minimumFractionDigits: 0,
});

export default {
  name: "CourseFloatingCard",
  components: { BCard, BCardBody, BFormCheckboxGroup, BFormCheckbox, BSkeleton, BSkeletonWrapper, Icon },
  props: {
    img: String,
    imgAlt: String,
    name: String,
    shortName: String,
    pricePesos: Number,
    priceUSD: Number,
    dateCourse: String,
    schedule: String,
    language: String,
    level: String,
    modality: String,
    places: Boolean,
    duration: String,
    category: String,
    graduationCertificate: Boolean,
    graduationCertificateExpires: Boolean,
    requiresPreviousKnowledge: Boolean
  },
  data() {
    return {
      paymentMethod: ["paypal"],
      buttonURL: "/es/concretar-compra",
      promo: "disable",
      priceMercadoPago: 0,
    }
  },
  computed: {
    loading() {
      return !(this.pricePesosString && this.priceUSD);
    },
    pricePesosString() {
      return this.pricePesos ? formatter.format(this.pricePesos) : "";
    },
  },
  methods: {
    onBtnClick() {
      this.$emit("btnClick");
      let payment = document.querySelector('input[name="checkboxes-payment-method"][type="checkbox"]:checked');
      payment != null ? sessionStorage.setItem('coursePaymentMethod', payment.value) : '';

      if (document.querySelector('input[name="payment-method-promo-check"][type="checkbox"]:checked')) {
        this.checkPromo();
      }
    },
    checkPromo: function () {
      let promoCheck = document.querySelector('input[name="payment-method-promo-check"][type="checkbox"]');
      sessionStorage.setItem('coursePaymentMethod', 'promo');

      if (document.querySelector('input[name="checkboxes-payment-method"][type="checkbox"]:checked') != null || document.querySelector('input[name="checkboxes-payment-method"][type="checkbox"]:checked') != undefined) {
        document.querySelector('input[name="checkboxes-payment-method"][type="checkbox"]:checked').checked = false;
      }

      if (promoCheck.check != undefined || promoCheck == 'active' || promoCheck.check != null) {
        sessionStorage.setItem('promo', 'disable');
        this.promo = 'disable';
      }
      else {
        sessionStorage.setItem('promo', 'active');
        this.promo = 'active';
        //this.getMercadoPagoURL(this.pricePesos - (this.pricePesos * 0.20).toFixed());
      }

    },
    check: function (e) {
      sessionStorage.setItem('coursePaymentMethod', e);
      let promoCheck = document.querySelector('input[name="payment-method-promo-check"][type="checkbox"]');
      promoCheck != null ? promoCheck.checked = false : '';
      this.promo = 'disable';
      sessionStorage.setItem('promo', 'disable');

      /*if (e == 'mercadopago') {
        if (this.name != 'Workshop de Chaos Testing y Chaos Engineering' && this.name != 'Software tester' && this.name != 'Performance de apps móviles con Apptim desktop') {
          this.getMercadoPagoURL(this.pricePesos - (this.pricePesos * 0.10).toFixed());
        } 
        else {
          this.getMercadoPagoURL(this.pricePesos);
        }
      }    
      else {
        document.querySelector("#floatingCardBtn").href = '/es/concretar-compra';
        document.querySelector("#courseBtn").href = '/es/concretar-compra';
        document.querySelector("#learningTopicBtn").href = '/es/concretar-compra';
      }*/
    },
    getMercadoPagoURL(price) {
      let preference = {
        back_urls: {
          success: "https://test.abstracta.us/academy/es/checkout/success",
          pending: "https://test.abstracta.us/academy/es/checkout/pending",
          failure: "https://test.abstracta.us/academy/es/checkout/failure",
        },
        items: [
          {
            title: this.name,
            description: this.shortName,
            currency_id: "UYU",
            unit_price: price,
            quantity: 1,
          },
        ],
        notification_url: "https://abstracta.academy/es/",
      };

      fetch("https://api.mercadopago.com/checkout/preferences", {
        method: "POST",
        headers: {
          "Authorization": "Bearer APP_USR-6743722642239926-040415-484c0ada8b11e83bb421c184bc9bdd91-1345772256",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(preference),
      })
        .then(response => response.json())
        .then(data => {
          sessionStorage.setItem('courseMercadoPagoURL', data.init_point);
          this.buttonURL = sessionStorage.courseMercadoPagoURL;
          document.querySelector("#floatingCardBtn").href = this.buttonURL;
          document.querySelector("#courseBtn").href = this.buttonURL;
          document.querySelector("#learningTopicBtn").href = this.buttonURL;
        })
        .catch(error => console.log(error));
    }
  },
  watch: {
    async paymentMethod(newVal, oldVal) {
      if (newVal.length == 0) {
        await this.$nextTick();
        this.paymentMethod = oldVal;
      }
      else if (newVal.length == 2) {
        await this.$nextTick();
        this.paymentMethod = newVal.filter(v => (!oldVal.includes(v)));
      }
    },
  },
  mounted() {
    let payment = document.querySelectorAll('input[name="checkboxes-payment-method"][type="checkbox"]:checked');
    sessionStorage.setItem('coursePaymentMethod', payment[0].value);
    let paymentPromo = document.querySelectorAll('input[name="payment-method-promo-check"][type="checkbox"]:checked');
    paymentPromo.checked ? sessionStorage.setItem('promo', 'active') : sessionStorage.setItem('promo', 'disable');
  }
};
